const Mutations = Object.freeze({
	SET_ACTIVITIES: 'activity/SET_ACTIVITIES',
	SET_LOADING: 'activity/SET_LOADING',
	SET_ACTIVITY_DATA: 'activity/SET_ACTIVITY_DATA',
	SET_STATIC_FIELDS: 'activity/SET_STATIC_FIELDS',
	SET_COMPUTED_FIELDS: 'activity/SET_COMPUTED_FIELDS',
	SET_GROUP_BY_FIELDS: 'activity/SET_GROUP_BY_FIELDS',
	SET_CONDITION_FIELDS_LIST: 'activity/SET_CONDITION_FIELDS_LIST',
	SET_GRID_VIEW_FIELDS: 'activity/SET_GRID_VIEW_FIELDS',
	SET_QUICK_FILTER: 'activity/SET_QUICK_FILTER',
	SET_ADVANCED_FILTER: 'activity/SET_ADVANCED_FILTER',
	SET_ROWS_PER_PAGE: 'activity/SET_ROWS_PER_PAGE',
	SET_TOTAL_COUNT: 'activity/SET_TOTAL_COUNT',
	SET_PAGE: 'activity/SET_PAGE',
});

export const Actions = Object.freeze({
	LOAD_ACTIVITIES: 'activity/LOAD_ACTIVITIES',
	CLEAR: 'activity/CLEAR',
	LOAD_ACTIVITY_DATA: 'activity/LOAD_ACTIVITY_DATA',
	LOAD_STATIC_FIELDS: 'activity/LOAD_STATIC_FIELDS',
	LOAD_GROUP_BY_FIELDS: 'activity/LOAD_GROUP_BY_FIELDS',
	LOAD_COMPUTED_FIELDS: 'activity/LOAD_COMPUTED_FIELDS',
	UPDATE_QUICK_FILTER: 'activity/UPDATE_QUICK_FILTER',
	UPDATE_ADVANCED_FILTER: 'activity/UPDATE_ADVANCED_FILTER',
	UPDATE_PAGE: 'activity/UPDATE_PAGE',
	UPDATE_ROWS_PER_PAGE: 'activity/UPDATE_ROWS_PER_PAGE',
	EXPORT_ACTIVITY_VISIBLE_DATA: 'activity/EXPORT_ACTIVITY_VISIBLE_DATA',
	EXPORT_ACTIVITY_ALL_DATA: 'activity/EXPORT_ACTIVITY_ALL_DATA',
	EXPORT_ACTIVITY_DETAILED_DATA: 'activity/EXPORT_ACTIVITY_DETAILED_DATA',
});

export const Getters = Object.freeze({
	DATA: 'activity/DATA',
	LOADING: 'activity/LOADING',
	ACTIVITIES: 'activity/ACTIVITIES',
	STATIC_FIELDS: 'activity/STATIC_FIELDS',
	COMPUTED_FIELDS: 'activity/COMPUTED_FIELDS',
	GROUP_BY_FIELDS: 'activity/GROUP_BY_FIELDS',
	CONDITION_FIELDS_LIST: 'activity/CONDITION_FIELDS_LIST',
	GRID_VIEW_FIELDS: 'activity/GRID_VIEW_FIELDS',
	QUICK_FILTER: 'activity/QUICK_FILTER',
	ADVANCED_FILTER: 'activity/ADVANCED_FILTER',
	ROWS_PER_PAGE: 'activity/ROWS_PER_PAGE',
	TOTAL_COUNT: 'activity/TOTAL_COUNT',
	PAGE: 'activity/PAGE',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/activityDataService';
import exportDataService from '../../../../../services/data/dataExportService';
import fileUtils from '../../../../../utils/fileUtils';
import { ExportMode } from '../../../../../enums/ExportMode';
import Snackbar from '../../../../../components/core/dialogs/snackbarMessage';
export default {
	state: {
		activities: [],
		loading: false,
		staticFields: [],
		computedFields: [],
		groupByFields: [],
		conditionFieldsList: [],
		data: [],
		gridViewFields: [],
		quickFilter: { FieldId: null, Value: '' },
		advancedFilter: { Operator: 1, Filters: [], FiltersCount: 0 },
		rowsPerPage: 50,
		page: 1,
		totalCount: 0,
	},
	mutations: {
		[Mutations.SET_ACTIVITIES](state, items) {
			state.activities = items;
		},
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_ACTIVITY_DATA](state, items) {
			state.data = items;
		},
		[Mutations.SET_STATIC_FIELDS](state, items) {
			state.staticFields = items;
		},
		[Mutations.SET_COMPUTED_FIELDS](state, items) {
			state.computedFields = items;
		},
		[Mutations.SET_GROUP_BY_FIELDS](state, items) {
			state.groupByFields = items;
		},
		[Mutations.SET_CONDITION_FIELDS_LIST](state, items) {
			state.conditionFieldsList = items;
		},
		[Mutations.SET_GRID_VIEW_FIELDS](state, items) {
			state.gridViewFields = items;
		},
		[Mutations.SET_QUICK_FILTER](state, item) {
			state.quickFilter = item;
		},
		[Mutations.SET_ADVANCED_FILTER](state, item) {
			state.advancedFilter = item;
		},
		[Mutations.SET_ROWS_PER_PAGE](state, item) {
			state.rowsPerPage = item;
		},
		[Mutations.SET_TOTAL_COUNT](state, item) {
			state.totalCount = item;
		},
		[Mutations.SET_PAGE](state, item) {
			state.page = item;
		},
	},

	actions: {
		[Actions.CLEAR]({ commit }) {
			commit(Mutations.SET_ACTIVITY_DATA, []);
			commit(Mutations.SET_STATIC_FIELDS, []);
			commit(Mutations.SET_COMPUTED_FIELDS, []);
			commit(Mutations.SET_GROUP_BY_FIELDS, []);
			commit(Mutations.SET_GRID_VIEW_FIELDS, []);
			commit(Mutations.SET_CONDITION_FIELDS_LIST, []);
			commit(Mutations.SET_TOTAL_COUNT, 0);
			commit(Mutations.SET_ADVANCED_FILTER, {
				Operator: 1,
				Filters: [],
				FiltersCount: 0,
			});
			commit(Mutations.SET_QUICK_FILTER, { FieldId: null, Value: '' });
		},

		[Actions.LOAD_ACTIVITIES]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getActivities()
					.then((resp) => {
						commit(Mutations.SET_ACTIVITIES, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_ACTIVITY_DATA]({ commit, dispatch, state }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				let payload = {
					ActivityId: id,
					IncludeCount: true,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
				};
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				Promise.all([
					dataService.getActivityData(payload).then((resp) => {
						commit(Mutations.SET_ACTIVITY_DATA, resp.data.Data),
							commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
					}),
					dataService
						.getComputedFieldsByActivityId(id)
						.then((resp) => {
							commit(Mutations.SET_COMPUTED_FIELDS, resp.data);
						}),
					dataService.getStaticFieldsByActivityId(id).then((resp) => {
						commit(Mutations.SET_STATIC_FIELDS, resp.data);
					}),
					dataService.getGrouByConditionFields(id).then((resp) => {
						commit(Mutations.SET_GROUP_BY_FIELDS, resp.data);
					}),
					dataService
						.getGroupByConditionFieldList(id)
						.then((resp) => {
							commit(
								Mutations.SET_CONDITION_FIELDS_LIST,
								resp.data
							);
						}),
					dataService
						.getGridViewFieldByDefaultEntity(id)
						.then((resp) => {
							commit(Mutations.SET_GRID_VIEW_FIELDS, resp.data);
						}),
				])
					.then(() => {
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_COMPUTED_FIELDS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getComputedFieldsByActivityId(id)
					.then((resp) => {
						commit(Mutations.SET_COMPUTED_FIELDS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_STATIC_FIELDS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getStaticFieldsByActivityId(id)
					.then((resp) => {
						commit(Mutations.SET_STATIC_FIELDS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_GROUP_BY_FIELDS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getGrouByConditionFields(id)
					.then((resp) => {
						commit(Mutations.SET_GROUP_BY_FIELDS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.EXPORT_ACTIVITY_VISIBLE_DATA](
			{ state, dispatch },
			{ id, isDirectMode = ExportMode.BACKGROUND }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let activityName =
					state.activities.find((x) => x.Id == id)?.Name ||
					'Activity';
				let payload = {
					ActivityId: id,
					ActivityName: activityName,
					IncludeCount: true,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
				};
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;

				// Choose export service based on export mode
				const exportService =
					isDirectMode === ExportMode.DIRECT
						? exportDataService.downloadActivityDirect
						: exportDataService.downloadActivity;
				exportService(payload)
					.then((resp) => {
						if (isDirectMode === ExportMode.DIRECT) {
							// Direct export - download immediately with proper filename handling
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);
							const filename = fileInfo.filename;

							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename);
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);
						} else {
							// Background export - show notification
							Snackbar({
								message:
									'Export request registered. You will receive a notification when the file is ready for download!',
								timeout: 5000,
							});
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.EXPORT_ACTIVITY_ALL_DATA](
			{ state, dispatch },
			{ id, isDirectMode = ExportMode.BACKGROUND }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let activityName =
					state.activities.find((x) => x.Id == id)?.Name ||
					'Activity';
				let payload = {
					ActivityId: id,
					ActivityName: activityName,
					IncludeCount: true,
					RowsPerPage: state.totalCount,
					Page: state.page,
				};
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;

				// Choose export service based on export mode
				const exportService =
					isDirectMode === ExportMode.DIRECT
						? exportDataService.downloadActivityDirect
						: exportDataService.downloadActivity;
				exportService(payload)
					.then((resp) => {
						if (isDirectMode === ExportMode.DIRECT) {
							// Direct export - download immediately with proper filename handling
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);
							const filename = fileInfo.filename;

							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename);
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);
						} else {
							// Background export - show notification
							Snackbar({
								message:
									'Export request registered. You will receive a notification when the file is ready for download!',
								timeout: 5000,
							});
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.EXPORT_ACTIVITY_DETAILED_DATA](
			{ state, dispatch },
			{ id, rows, isDirectMode = ExportMode.BACKGROUND }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let activityName =
					state.activities.find((x) => x.Id == id)?.Name ||
					'Activity';
				let payload = {};
				if (rows && rows.length > 0) {
					let stringObjects = [];
					rows.forEach((x) => {
						stringObjects.push(JSON.stringify(x));
					});
					payload = {
						ActivityId: id,
						ActivityName: activityName,
						Rows: stringObjects,
					};
				}

				// Choose export service based on export mode
				const exportService =
					isDirectMode === ExportMode.DIRECT
						? exportDataService.downloadDetailedActivityDirect
						: exportDataService.downloadDetailedActivity;
				exportService(payload)
					.then((resp) => {
						if (isDirectMode === ExportMode.DIRECT) {
							// Direct export - download immediately with proper filename handling
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);

							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', fileInfo.filename);
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);
						} else {
							// Background export - show notification
							Snackbar({
								message:
									'Export request registered. You will receive a notification when the file is ready for download!',
								timeout: 5000,
							});
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_QUICK_FILTER](
			{ commit, dispatch },
			{ filter: value, id: id }
		) {
			commit(Mutations.SET_QUICK_FILTER, value);
			dispatch(Actions.LOAD_ACTIVITY_DATA, id);
		},
		[Actions.UPDATE_ADVANCED_FILTER](
			{ commit, dispatch },
			{ filter: value, id: id }
		) {
			commit(Mutations.SET_ADVANCED_FILTER, value);
			dispatch(Actions.LOAD_ACTIVITY_DATA, id);
		},
		[Actions.UPDATE_PAGE]({ commit, dispatch }, { page: value, id: id }) {
			commit(Mutations.SET_PAGE, value);
			dispatch(Actions.LOAD_ACTIVITY_DATA, id);
		},
		[Actions.UPDATE_ROWS_PER_PAGE](
			{ commit, dispatch },
			{ rowsPerPage: value, id: id }
		) {
			commit(Mutations.SET_ROWS_PER_PAGE, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_ACTIVITY_DATA, id);
		},
	},
	getters: {
		[Getters.ACTIVITIES]: (state) => {
			return JSON.parse(JSON.stringify(state.activities));
		},
		[Getters.DATA]: (state) => {
			return JSON.parse(JSON.stringify(state.data));
		},
		[Getters.STATIC_FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.staticFields));
		},
		[Getters.COMPUTED_FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.computedFields));
		},
		[Getters.GROUP_BY_FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.groupByFields));
		},
		[Getters.CONDITION_FIELDS_LIST]: (state) => {
			return JSON.parse(JSON.stringify(state.conditionFieldsList));
		},
		[Getters.GRID_VIEW_FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.gridViewFields));
		},
		[Getters.QUICK_FILTER]: (state) => {
			return JSON.parse(JSON.stringify(state.quickFilter));
		},
		[Getters.ADVANCED_FILTER]: (state) => {
			return JSON.parse(JSON.stringify(state.advancedFilter));
		},
		[Getters.LOADING]: (state) => {
			return state.loading;
		},
		[Getters.TOTAL_COUNT]: (state) => {
			return state.totalCount;
		},
		[Getters.PAGE]: (state) => {
			return state.page;
		},
		[Getters.ROWS_PER_PAGE]: (state) => {
			return state.rowsPerPage;
		},
	},
};
